import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/check.svg';
import MerchantReinsurance from '~/components/molecules/Product/MerchantReinsurance.vue';
import ProductOffers from '~/components/molecules/Product/ProductOffers.vue';
import USE_MARKETPLACE from '~/const/marketplace';
import { DELIVERY_FAQ, RETURN_FAQ } from '~/const/faq';
export default {
  name: 'Reinsurance',
  components: {
    MerchantReinsurance,
    ProductOffers
  },
  props: {
    deliveryPayload: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    activeDeliveryPayload() {
      const openStores = ['fr-FR', 'fr-BE', 'nl-BE', 'fr-CH', 'de-CH', 'it-CH', 'de-DE', 'fr-LU', 'it-IT', 'es-ES'];
      return openStores.includes(this.locale.iso);
    },

    merchantUrl() {
      return this.buildMerchantUrl(this.locale, this.product.offer.merchant.reference);
    },

    returnsUrl() {
      return RETURN_FAQ[this.locale.iso] && RETURN_FAQ[this.locale.iso].returnsUrl;
    },

    homeDeliveryText() {
      return this.product.marketplace || this.locale.iso === 'en-GB' ? this.$t('homeDeliveryWithoutWithdrawal') : this.$t('homeDelivery');
    },

    deliveryUrl() {
      return DELIVERY_FAQ[this.locale.iso] && DELIVERY_FAQ[this.locale.iso].deliveryUrl;
    },

    isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    },

    tradReturn() {
      // Needed for FR
      return this.locale.market === 'FR' ? this.$t('return') : this.$t('returns').toLowerCase();
    }

  }),
  methods: {
    handleClickMerchant(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_vendeur',
          event_label: this.product.offer.merchant.name
        }
      });
    },

    handleClickDelivery(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Livraison',
          event_label: 'Clic_FAQ_Livraison'
        }
      });
    },

    handleClickReturns(event) {
      this.$root.$emit('generic-tracking', event, {
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_FAQ_Retours',
          event_label: 'Clic_FAQ_Retours'
        }
      });
    }

  }
};